import React, { useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import { withRouter } from "react-router"
import { Formik, Form, Field, ErrorMessage } from 'formik'
import config from '../../attribute-position-config.json'
import FieldWrapper from '../forms/FieldWrapper'
import ButtonSubmitCancel from '../general/ButtonSubmitCancel'
import WrapperAccordion from '../general/WrapperAccordion';
import { GRID_IMAGE, IMAGE, METRO, TEXT, TITLE } from '../../constants/itemTypes'
import ImageDisplayAndUpload from './fields/ImageDisplayAndUpload'
import { TextEditor } from './fields/TextEditor';
import Translation from '../Translation/cont/Translation';
import { EDIT_PRINT_CAP } from '../../constants/caps';
import RadioButtonGroup from './fields/RadioButtonGroup';
import RadioButton from './fields/RadioButton';
import DatepickerContainer from './fields/DatepickerContainer';
import { sanitizeFormInput, sanitizeFormOutput } from '../../functions/formFunctions';

const FormElementData = ({ history, closePagePath, itemData, onUpdateItem, itemType, elementType}) => {

    return (
        <Formik
            initialValues={sanitizeFormInput(itemData)}
            onSubmit={(values, actions) => {
                if(!values.id) {
                    values.id = uuidv4()
                }

                onUpdateItem(sanitizeFormOutput(values), elementType)
                history.push(closePagePath)
            }}
            
            onReset={(values, actions) => {
                history.push(closePagePath)
            }}
        >
        {({ values, errors, status, touched, isSubmitting, handleReset, setFieldValue }) => (
                <Form>
                    <WrapperAccordion
                        className="single-section"
                        selectionActiveClass="accordion-item-open"
                    >
                        <fieldset>
                            <div className="form-content highlight">
                                <div className="left-sections">
                                    {itemType === TITLE ? (
                                        <FieldWrapper label={<Translation id="print_flyer_heading"/>} id="content-title" classes="field-text">
                                            <Field type="text" name="payload" id="content-title" className="text-regular input-text-box" />
                                            <ErrorMessage className="text-regular-color" name="payload" component="div" /> 
                                        </FieldWrapper>
                                    ) : itemType === TEXT ? (
                                        <FieldWrapper label="" id="content-title" classes="field-textarea field-textarea-text">
                                            <TextEditor
                                                setFieldValue={(val) => setFieldValue("payload", val)}
                                                value={values.payload}
                                            />
                                            <ErrorMessage className="text-regular-color" name="payload" component="div" /> 
                                        </FieldWrapper>
                                    ) : itemType === IMAGE ? (
                                        <div className='flyer-image-data'>
                                            <FieldWrapper classes="image" label={<Translation id="print_flyer_image_element"/>} id="content-image" >
                                                <Field 
                                                    name="payload"
                                                    component={ImageDisplayAndUpload}
                                                />
                                            </FieldWrapper>
                                            <FieldWrapper label={<Translation id="print_flyer_image_element_width"/>} id="content-title" classes="field-text">
                                                <Field type="text" name="width" id="content-title" className="text-regular input-text-box" />
                                                <ErrorMessage className="text-regular-color" name="width" component="div" /> 
                                            </FieldWrapper>
                                            <FieldWrapper label={<Translation id="print_flyer_image_element_height"/>} id="content-title" classes="field-text">
                                                <Field type="text" name="height" id="content-title" className="text-regular input-text-box" />
                                                <ErrorMessage className="text-regular-color" name="height" component="div" /> 
                                            </FieldWrapper>
                                            <FieldWrapper label={<Translation id="print_flyer_image_element_position_x"/>} id="content-title" classes="field-text">
                                                <Field type="text" name="position_x" id="content-title" className="text-regular input-text-box" />
                                                <ErrorMessage className="text-regular-color" name="position_x" component="div" /> 
                                            </FieldWrapper>
                                            <FieldWrapper label={<Translation id="print_flyer_image_element_position_y"/>} id="content-title" classes="field-text">
                                                <Field type="text" name="position_y" id="content-title" className="text-regular input-text-box" />
                                                <ErrorMessage className="text-regular-color" name="position_y" component="div" /> 
                                            </FieldWrapper>
                                        </div>
                                    ) : itemType === METRO ? (
                                        <div className='flyer-metro-data'>
                                            <FieldWrapper label={<Translation id="movie_edit_movie_title"/>} id="metro-title" classes="field-text">
                                                <Field type="text" name="title" id="metro-title" className="text-regular input-text-box" />
                                                <ErrorMessage className="text-regular-color" name="title" component="div" /> 
                                            </FieldWrapper>

                                            <FieldWrapper label={<Translation id="movie_edit_movie_description" />} id="metro-description" classes="field-textarea field-textarea-text">
                                                <Field type="text" name="description" id="metro-description" className="text-regular input-text-box" component="textarea"/>
                                                <ErrorMessage className="text-regular-color" name="description" component="div" /> 
                                            </FieldWrapper>

                                            <div className="datepicker-container field-all">
                                                <FieldWrapper label={<Translation id="formik_datepicker_date"/>} id="movie-startdate" classes="datepicker-inner-wrapper">
                                                    <DatepickerContainer value={values.date} start={true} name="date" onChange={setFieldValue} type="text" id="movie-startdate" className="text-small-light input-text-box" />
                                                    <ErrorMessage name="date" component="div" />
                                                </FieldWrapper>
                                            </div>

                                            <FieldWrapper classes="field-all image" label={<Translation id="images_movie_poster"/>} id="metro-image" >
                                                <Field 
                                                    name="image"
                                                    component={ImageDisplayAndUpload}
                                                />
                                            </FieldWrapper>
                                            
                                            <FieldWrapper label={<Translation id="print_flyer_image_element_position_x"/>} id="metro-position-x" classes="field-text">
                                                <Field type="text" name="position_x" id="metro-position-x" className="text-regular input-text-box" />
                                                <ErrorMessage className="text-regular-color" name="position_x" component="div" /> 
                                            </FieldWrapper>

                                            <FieldWrapper label={<Translation id="print_flyer_image_element_position_y"/>} id="metro-position-y" classes="field-text">
                                                <Field type="text" name="position_y" id="metro-position-y" className="text-regular input-text-box" />
                                                <ErrorMessage className="text-regular-color" name="position_y" component="div" /> 
                                            </FieldWrapper>
                                        </div>
                                    ) : itemType === GRID_IMAGE ? (
                                        <div className='flyer-gridimages-data'>
                                            <FieldWrapper label={<Translation id="print_flyer_designation"/>} id="grid-image-text" classes="field-text">
                                                <Field type="text" id="grid-image-text" name='text' className="text-regular input-text-box" />
                                                <ErrorMessage name='text' component="div"/> 
                                            </FieldWrapper>

                                            <RadioButtonGroup
                                                label={<Translation id="print_flyer_position" />}
                                                className="select-new-section-type attribute-position"
                                            >
                                                {config.positions.map(({transId, id}) => <Field
                                                        key={id}
                                                        component={RadioButton}
                                                        name='position'
                                                        id={id}
                                                        label={<Translation id={transId}/>}
                                                    />
                                                )}
                                            </RadioButtonGroup>
                                        </div>
                                    ) : (
                                        <div><Translation id="print_flyer_no_item_to_edit"/></div>
                                    )}
                                </div>
                            </div>
        
                            <ButtonSubmitCancel
                                transIdCancel="cancel_button"
                                transIdSubmit="save_item_button"
                                cap={EDIT_PRINT_CAP}
                                disabledCancel={isSubmitting}
                                disabledSubmit={isSubmitting}
                                onCancel={handleReset}
                            />
                        </fieldset>
                    </WrapperAccordion>
                </Form>
            )}

        </Formik>
    )

}

export default withRouter(FormElementData) 